export default function() {
	const setColumnHeight = () => {
		document.querySelectorAll('.site-columns-content__collapsible-1').forEach((_col) => {
			const h = _col.querySelector('.site-columns-content__content').scrollHeight;
			_col.style.setProperty('--column-content-height', h);
		});
	};
	document.querySelectorAll('.site-columns-content__collapsible-1').forEach((_col) => {
		_col.querySelector('.site-columns-content__heading').addEventListener('click', () => {
			_col.classList.toggle('site-columns-content__collapsible-open');
		});
	});
	window.addEventListener('resize', () => {
		setColumnHeight();
	}); setColumnHeight();
}
